(function () {
  'use strict';

  if (window.__gorgiasChatLinkHandler) return;
  window.__gorgiasChatLinkHandler = true;

  var chatLinkSelector = 'a[href="#chat"], a[href="#live-chat"], a[href*="gs_open_chat"], [data-gorgias-chat-link]';
  var chatDeepLink = /(?:^|[?&])gs_open_chat(?:[=&]|$)/.test(window.location.search);
  var gorgiasReady = window.GorgiasChat
    ? (typeof window.GorgiasChat.init === 'function' ? Promise.resolve(window.GorgiasChat.init()) : Promise.resolve())
    : new Promise(function (resolve) {
        window.addEventListener('gorgias-widget-loaded', resolve, { once: true });
      });

  function isVisible(element) {
    return Boolean(element && element.getClientRects().length && window.getComputedStyle(element).visibility !== 'hidden');
  }

  function closeMobileNavigation(link) {
    var drawer = link.closest('.menu-drawer, .mobile-navigation-drawer, .mobile-nav, .mobile-menu, .drawer, [role="dialog"]');
    var closeSelector = '.menu-drawer__close-button, .menu-close-btns, .mobile-nav-toggle[aria-label*="Close"], .drawer__close, .mobile-nav__close, button[aria-label*="Close"]';
    var close = drawer && drawer.querySelector(closeSelector);

    if (!isVisible(close) && drawer) {
      close = Array.prototype.find.call(drawer.querySelectorAll('button, a'), function (element) {
        var label = (element.getAttribute('aria-label') || '') + ' ' + (element.textContent || '');
        return /close (menu|navigation|drawer)/i.test(label) && isVisible(element);
      });
    }

    if (!isVisible(close)) {
      close = Array.prototype.find.call(
        document.querySelectorAll('summary.header__icon--menu[aria-expanded="true"], [aria-controls="menu-drawer"][aria-expanded="true"], [aria-controls="mobile-menu"][aria-expanded="true"], .mobile-nav-toggle[aria-expanded="true"], .header__mobile-nav-toggle[aria-expanded="true"]'),
        isVisible
      );
    }

    if (isVisible(close)) {
      close.click();
      return true;
    }

    return false;
  }

  function chatWindowIsOpen() {
    var frame = document.getElementById('chat-window');
    if (!frame) return false;
    var rect = frame.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && window.getComputedStyle(frame).visibility !== 'hidden';
  }

  function clickLauncher() {
    try {
      var frame = document.getElementById('chat-button');
      var button = frame && frame.contentDocument && frame.contentDocument.querySelector('button');
      if (button && !button.disabled) {
        button.click();
        return true;
      }
    } catch (error) {
      // A future cross-origin launcher cannot be opened through its document.
    }
    return false;
  }

  function openWithApi() {
    var chat = window.GorgiasChat;
    if (!chat) return false;

    var methods = [
      [chat, chat.open],
      [chat, chat.openChat],
      [chat, chat.show],
      [chat.api, chat.api && chat.api.open]
    ];

    for (var i = 0; i < methods.length; i += 1) {
      if (typeof methods[i][1] === 'function') {
        methods[i][1].call(methods[i][0]);
        return true;
      }
    }

    return false;
  }

  function openWithUrlParameter() {
    if (chatDeepLink) return;

    var separator = window.location.search ? '&' : '?';
    window.location.assign(window.location.origin + window.location.pathname + window.location.search + separator + 'gs_open_chat');
  }

  function clearChatDeepLink() {
    if (!chatDeepLink) return;

    var url = new URL(window.location.href);
    url.searchParams.delete('gs_open_chat');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    chatDeepLink = false;
  }

  function openChat() {
    var attempts = 0;
    var apiReady = false;

    function tryOpen() {
      if (chatWindowIsOpen()) {
        clearChatDeepLink();
        return;
      }

      if (apiReady && !openWithApi()) clickLauncher();

      if (chatWindowIsOpen()) {
        clearChatDeepLink();
        return;
      }

      attempts += 1;
      if (attempts < 40 && !chatWindowIsOpen()) {
        window.setTimeout(tryOpen, 175);
      } else if (!chatWindowIsOpen()) {
        openWithUrlParameter();
      }
    }

    gorgiasReady
      .then(function () {
        if (window.GorgiasChat && typeof window.GorgiasChat.hideOnMobile === 'function') {
          window.GorgiasChat.hideOnMobile(false);
        }
        apiReady = true;
        tryOpen();
      })
      .catch(function () {
        // The URL fallback below remains available if initialization fails.
      });

    tryOpen();
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var link = event.target.closest(chatLinkSelector);
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    if (link.matches('a[href*="gs_open_chat"]')) {
      try {
        var destination = new URL(link.href, window.location.href);
        if (destination.origin !== window.location.origin || !destination.searchParams.has('gs_open_chat')) return;
      } catch (error) {
        return;
      }
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    var navigationClosed = closeMobileNavigation(link);
    window.setTimeout(openChat, navigationClosed ? 450 : 0);
  }, true);

  if (chatDeepLink) openChat();
})();
